import { render, staticRenderFns } from "./DvrCameraUpdateDialog.vue?vue&type=template&id=dcb3eb0a&scoped=true"
import script from "./DvrCameraUpdateDialog.vue?vue&type=script&lang=js"
export * from "./DvrCameraUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./DvrCameraUpdateDialog.vue?vue&type=style&index=0&id=dcb3eb0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb3eb0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcb3eb0a')) {
      api.createRecord('dcb3eb0a', component.options)
    } else {
      api.reload('dcb3eb0a', component.options)
    }
    module.hot.accept("./DvrCameraUpdateDialog.vue?vue&type=template&id=dcb3eb0a&scoped=true", function () {
      api.rerender('dcb3eb0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/camera/DvrCameraUpdateDialog.vue"
export default component.exports